// ** Redux Imports
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

// ** Axios Imports
import API from 'api/orders'

export const list = createAsyncThunk('appOrderServiceTypes/list', async () => {
  return await API.listOrderServiceTypes()
})

export const get = createAsyncThunk('appOrderServiceTypes/get', async name => {
  return await API.getOrderServiceType(name)
})

export const add = createAsyncThunk('appOrderServiceTypes/add', async (instance, { dispatch }) => {
  const updated = await API.createOrderServiceType(instance)
  instance = {
    ...instance,
    updated
  }
  await dispatch(list())
  return instance
})

export const modify = createAsyncThunk('appOrderServiceTypes/modify', async (instance, { dispatch }) => {
  const updated = await API.updateOrderServiceType(instance)
  instance = {
    ...instance,
    updated
  }
  await dispatch(appOrderServiceTypesSlice.actions.setSelected(instance))
  await dispatch(list())
})

export const del = createAsyncThunk('appOrderServiceTypes/del', async (name, { dispatch }) => {
  await API.deleteOrderServiceType(name)
  await dispatch(list())
  return name
})

export const appOrderServiceTypesSlice = createSlice({
  name: 'appOrderServiceTypes',
  initialState: {
    data: [],
    selected: null
  },
  reducers: {
    setSelected: (state, { payload }) => {
      state.selected = payload
    }
  },  extraReducers: builder => {
    builder
      .addCase(list.fulfilled, (state, action) => {
        state.data = action.payload
      })
      .addCase(get.fulfilled, (state, { payload }) => {
        state.selected = payload
      })
  }
})

export default appOrderServiceTypesSlice.reducer
